module.exports = __webpack_public_path__ + "static/media/truecaller_icon_small.580ee249.svg";